import {
    AspectRatio,
    Box,
    Flex,
    Heading,
    Image,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Text,
    useDisclosure,
} from '@chakra-ui/react';
import { FC } from 'react';
import { DownloadableInterface } from '../../types/stock';

type Props = {
    downloadable: DownloadableInterface;
};

export const DownloadbleImage: FC<Props> = ({ downloadable }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <>
            <Box
                borderWidth={1}
                px={4}
                py={4}
                onClick={onOpen}
                _hover={{ cursor: 'pointer', bgColor: 'gray.50' }}
            >
                <AspectRatio ratio={4 / 3}>
                    <Image src={downloadable.url} alt={downloadable.title} />
                </AspectRatio>
            </Box>

            {downloadable.title && (
                <Heading mt={4} size={'sm'} color={'secondary'}>
                    {downloadable.title}
                </Heading>
            )}

            <Modal isOpen={isOpen} onClose={onClose} size={'xl'}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader pb={2}>
                        <Flex justifyContent={'flex-end'}>
                            <ModalCloseButton position={'initial'} />
                        </Flex>
                    </ModalHeader>
                    <ModalBody pb={4}>
                        <Image
                            src={downloadable.url}
                            alt={downloadable.title}
                        />

                        {downloadable.title && (
                            <Text as={'em'} mt={4} display={'block'}>
                                {downloadable.title}
                            </Text>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};
